import { Http } from "../Http";
import { BookingCancellationResponseDto } from "../../../Api/Model/BookingCancellation/BookingCancellationResponseDto.csharp";
import { BookingCancellationConfirmationRequestDto } from "../../../Api/Model/BookingCancellation/BookingCancellationConfirmationRequestDto.csharp";
import { BookingCancellationRequestDto } from "../../../Api/Model/BookingCancellation/BookingCancellationRequestDto.csharp";
import { BookingDto } from "../../../Api/Model/BookingDto.csharp";
import { CreateMetodikaBookingResponseDto } from "../../../Api/Model/CreateMetodikaBookingResponseDto.csharp";
import { CreateBookingResponseDto } from "../../../Api/Model/CreateBookingResponseDto.csharp";
import { DropInAppointmentRequestDto } from "../../../Api/Model/DropInAppointmentRequestDto.csharp";
import { ConfirmBookingRequestDto } from "../../../Api/Model/ConfirmBookingRequestDto.csharp";
import { BookingCancellationConfCodeRequestDto } from "../../../Api/Model/BookingCancellation/BookingCancellationConfCodeRequestDto.csharp";

export interface IBookingApi {
  create(request: BookingDto): Promise<CreateBookingResponseDto>;
  createMetodika(
    request: BookingDto,
  ): Promise<CreateMetodikaBookingResponseDto>;
  dropIn(
    request: DropInAppointmentRequestDto,
  ): Promise<CreateBookingResponseDto>;
  confirm(request: ConfirmBookingRequestDto): Promise<CreateBookingResponseDto>;
  sendCancellationRequest(
    request: BookingCancellationRequestDto,
  ): Promise<BookingCancellationResponseDto>;
  sendCancelConfirmationCode(
    request: BookingCancellationConfirmationRequestDto,
  ): Promise<BookingCancellationResponseDto>;
  sendCancellationConfirmation(
    request: BookingCancellationConfirmationRequestDto,
  ): Promise<BookingCancellationResponseDto>;
}

export class BookingApi implements IBookingApi {
  public create = (request: BookingDto): Promise<CreateBookingResponseDto> => {
    return Http.post(
      `/api/bookings`,
      request,
    ) as Promise<CreateBookingResponseDto>;
  };

  public createMetodika = (
    request: BookingDto,
  ): Promise<CreateMetodikaBookingResponseDto> => {
    return Http.post(
      `/api/bookings/metodika`,
      request,
    ) as Promise<CreateMetodikaBookingResponseDto>;
  };

  public dropIn = (
    request: DropInAppointmentRequestDto,
  ): Promise<CreateBookingResponseDto> => {
    return Http.post(
      `/api/bookings/drop-in`,
      request,
    ) as Promise<CreateBookingResponseDto>;
  };

  public dropInMetodika = (
    request: DropInAppointmentRequestDto,
  ): Promise<CreateBookingResponseDto> => {
    return Http.post(
      `/api/bookings/drop-in-metodika`,
      request,
    ) as Promise<CreateBookingResponseDto>;
  };

  public confirm = (
    request: ConfirmBookingRequestDto,
  ): Promise<CreateBookingResponseDto> => {
    return Http.post(
      `/api/bookings/confirmed`,
      request,
    ) as Promise<CreateBookingResponseDto>;
  };
  public sendCancellationRequest = (
    request: BookingCancellationRequestDto,
  ): Promise<BookingCancellationResponseDto> => {
    return Http.post(
      "/api/booking-cancellation/send",
      request,
    ) as Promise<BookingCancellationResponseDto>;
  };
  public sendCancelConfirmationCode = (
    request: BookingCancellationConfCodeRequestDto,
  ): Promise<BookingCancellationResponseDto> => {
    return Http.post(
      "/api/booking-cancellation/send-confirmation-code",
      request,
    ) as Promise<BookingCancellationResponseDto>;
  };
  public sendCancellationConfirmation = (
    request: BookingCancellationConfirmationRequestDto,
  ): Promise<BookingCancellationResponseDto> => {
    return Http.post(
      "/api/booking-cancellation/confirm",
      request,
    ) as Promise<BookingCancellationResponseDto>;
  };
}
